import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What's the difference between the two grades?",
    a: "Uji specialty (Gokou × Samidori) is a first-flush, shade-grown, stone-milled grade meant to be tasted on its own — no milk, no sugar. Shizuoka everyday is a first-harvest custom blend built to hold up against milk, ice and fruit. We never substitute one for the other to protect a margin.",
  },
  {
    q: "Why doesn't the pass discount apply to the Uji bowl?",
    a: "Because discounting it would mean either losing money on each cup or quietly downgrading what's in it. Uji specialty stays full-price always — founding members, pass-holders, everyone. The pass applies to Shizuoka-grade drinks, the grade designed to be had often.",
  },
  {
    q: "How does the founding free cup work?",
    a: "Complete the four-question survey and signup. Your seat is held against one of 100 founding spots. On opening week we email a digital pass tied to your phone — redeemable for your first Shizuoka-grade drink, on us.",
  },
  {
    q: "How does the UPI payment work?",
    a: "Scan the QR in the Matcha Pass modal (or open the UPI deep-link on mobile), pay the exact amount, and submit your UTR/reference number with your name & email. We verify it against our UPI account and email your pass within a few hours. No card processor in the middle.",
  },
  {
    q: "Where are you, exactly?",
    a: "A slow-bar near Mall of Dehradun. It's a beginning, not a flagship — we want to prove the model with real cups served to real regulars before it becomes anything bigger.",
  },
  {
    q: "I'm new to matcha. Where do I start?",
    a: "Honestly? An iced matcha latte on the Shizuoka grade. If that lands, come back for the Uji usucha — the unmasked version, savoury and lingering. We'll tell you what you're tasting, not perform a ceremony about it.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="px-6 md:px-10 py-24 md:py-32 bg-[#F1EEE6]/40" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <p className="overline text-[#C47253] mb-4">Plain Answers</p>
        <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] text-[#1A2B22] mb-12">
          Questions, <em className="text-[#2C4C3B]">answered straight</em>.
        </h2>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-border rounded-2xl px-6 bg-background"
            >
              <AccordionTrigger
                className="font-serif text-lg md:text-xl text-[#1A2B22] hover:no-underline text-left"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5C7365] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
